<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="pageTitle"
      [subtitle]="pageSubtitle"
      [inlineSubtitle]="true"
      [canGoBack]="true"
      [customBack]="backPage || 'messages'"
      [showLinkIcon]="loaded && !!contactInfo"
      [linkIcon]="'contact'"
      [linkIconSrc]="contactIconSrc"
      [linkIconSize]="27"
      (linkAction)="openContact()" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    <div [ngClass]="windowService.isDesktopRes ? 'desktop-content-padding' : 'mobile-content-padding'">
      @if (messageForm) {
        <form [formGroup]="messageForm">
                @if (isMessagesLoaded && !(messages.length >= this.totalMessages)) {
                  <ion-infinite-scroll position="top" threshold="15%" (ionInfinite)="getPageChangeMessages($event)">
                    <ion-infinite-scroll-content
                      loadingSpinner="bubbles"
                      loadingText="Loading older messages..." />
                  </ion-infinite-scroll>
                }
                @if (isProSelected) {
                  @if (isMessagesLoaded) {
                    @if (messages?.length == 0) {
                      <tidy-row [align]="'center'">
                        <tidy-text [helper]="'No Messages'" />
                      </tidy-row>
                    }
                    <div class="chat-messages-container">
                      @for (message of messages; track message; let i = $index) {
                        @if (shouldShowTimeIndicator(message, i)) {
                          <div class="time-indicator">
                            {{ message.sent_at | timeIndicator }}
                          </div>
                        }
                        @if (message.type === 'inquiry') {
                          <div class="chat-message other inquiry-message">
                            <div class="message-content-col">
                              <app-inquiry-card [message]="message" (openInquiry)="openInquiry(message)" />
                            </div>
                          </div>
                        } @else {
                        <div class="chat-message"
                             [class.user]="!(message.from_member | isCounterpartyMessage)"
                             [class.other]="message.from_member | isCounterpartyMessage"
                             [class.last-in-group]="isLastInGroup(message, i)">
                          <div class="message-content-col">
                            @if ((message.from_member | isCounterpartyMessage) && isLastInGroup(message, i)) {
                              <tidy-initials-icon [fullName]="(message.from_member?.first_name || '') + ' ' + (message.from_member?.last_name || '')" class="message-avatar-initials" />
                            }
                            <div class="message-bubble">
                              @if (message.content?.text) {
                                <div class="message-text" [innerHTML]="message.content.text | linkify | enrichLinks"></div>
                              }
                              @if (message.content?.files?.length) {
                                <attachment-carousel
                                  [files]="message.content.files"
                                  [downloadAction]="downloadFile" />
                              }
                            </div>
                            @if (message.was_sent_by === 'concierge') {
                              <div class="concierge-label-row">
                                <tidy-text [smallHelper]="'Sent by Concierge'" />
                              </div>
                              <div class="feedback-row">
                                <tidy-pill-button
                                  class="small"
                                  [image]="'assets/svg/settings-outline.svg'"
                                  (buttonClick)="goToConciergeMessageAgent()" />
                                <tidy-pill-button
                                  class="small"
                                  [image]="'assets/svg/thumbs-up-outline.svg'"
                                  (buttonClick)="onMessageThumbClick(message, 'positive')" />
                                <tidy-pill-button
                                  class="small"
                                  [image]="'assets/svg/thumbs-down-outline.svg'"
                                  (buttonClick)="onMessageThumbClick(message, 'negative')" />
                              </div>
                              @if (activeFeedbackMessageId === message.id || closingFeedbackMessageId === message.id) {
                                <div class="concierge-feedback-form" [class.closing]="closingFeedbackMessageId === message.id">
                                  <div class="concierge-feedback-header">
                                    {{ activeFeedbackType === 'positive' ? 'What did you like?' : 'What could be improved?' }}
                                  </div>
                                  <textarea
                                    class="concierge-feedback-textarea"
                                    [placeholder]="activeFeedbackType === 'positive' ? ('Tell us what was helpful...' | translate) : ('Tell us how we can do better...' | translate)"></textarea>
                                  <div class="concierge-feedback-actions">
                                    <button class="concierge-feedback-cancel" (click)="cancelMessageFeedback()">Cancel</button>
                                    <button class="concierge-feedback-submit" [disabled]="isSubmittingFeedback" (click)="submitMessageFeedback(message)">
                                      {{ isSubmittingFeedback ? 'Sending...' : 'Submit' }}
                                    </button>
                                  </div>
                                </div>
                              }
                            }
                          </div>
                        </div>
                        }
                      }
                    </div>
                  }
                }
                <!-- First-load skeleton: mirrors the loaded thread exactly — same
                     .chat-messages-container / .chat-message / bubble metrics — so the
                     swap to real messages happens in place. isMessagesLoaded never
                     flips back, so this can't replay on route reuse. -->
                @if (!isMessagesLoaded && isProSelected) {
                  <div class="chat-messages-container thread-skeleton-scope sk-thread">
                    <div class="time-indicator sk-item">
                      <ion-skeleton-text [animated]="true" class="sk-time-indicator" />
                    </div>
                    @for (bubble of skeletonThreadBubbles; track $index) {
                      <div class="chat-message sk-item"
                           [class.user]="bubble.side === 'user'"
                           [class.other]="bubble.side === 'other'"
                           [class.last-in-group]="bubble.last">
                        <div class="message-content-col">
                          @if (bubble.side === 'other' && bubble.last) {
                            <ion-skeleton-text [animated]="true" class="message-avatar-initials sk-msg-avatar" />
                          }
                          <ion-skeleton-text [animated]="true" class="sk-bubble" />
                        </div>
                      </div>
                    }
                  </div>
                }
              </form>
            }
          </div>

        </tidy-wrapper>
      </ng-template>

      @if (!windowService.isDesktopRes) {
        <app-scroll-wrapper [templateContent]="content" #messageContent />
        <div class="chat-input-area chat-input-area-mobile">
          @if (attachmentPreviews.length > 0) {
            <div class="attachment-preview-container">
              @for (attachment of attachmentPreviews; track attachment.url; let i = $index) {
                @if (attachment.isImage) {
                  <div class="image-preview">
                    <img [src]="attachment.url" />
                    <div class="remove-image-button">
                      <button mat-icon-button (click)="removeAttachment(i)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  </div>
                } @else {
                  <div class="file-preview">
                    <img src="assets/svg/document-outline.svg" class="file-preview-icon" />
                    <span class="file-preview-name">{{ attachment.filename }}</span>
                    <button mat-icon-button (click)="removeAttachment(i)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                }
              }
            </div>
          }
          <form [formGroup]="messageForm" novalidate action="#">
            <tidy-message-input
              #messageInput
              formControlName="message"
              [placeholder]="'Send Message'"
              [form]="messageForm.controls.message"
              [rightIconAction]="boundSendMessage"
              [leftIconAction]="((pro?.chat_room_key || chatRoomKey) | isTextOnlyGuestChatRoom: pro?.isGuest) ? null : boundSendAttachment"
              [icon]="null"
              [isSendingMessage]="isSendingMessage"
              [hasAttachment]="attachmentPreviews.length > 0" />
          </form>
        </div>
      }

      @if (windowService.isDesktopRes) {
        <ion-content class="ion-content-right-column" #messageContent>
          <ng-container *ngTemplateOutlet="content" />
          <div class="chat-input-area chat-input-area-desktop">
            @if (attachmentPreviews.length > 0) {
              <div class="attachment-preview-container">
                @for (attachment of attachmentPreviews; track attachment.url; let i = $index) {
                  @if (attachment.isImage) {
                    <div class="image-preview">
                      <img [src]="attachment.url" />
                      <div class="remove-image-button">
                        <button mat-icon-button (click)="removeAttachment(i)">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    </div>
                  } @else {
                    <div class="file-preview">
                      <img src="assets/svg/document-outline.svg" class="file-preview-icon" />
                      <span class="file-preview-name">{{ attachment.filename }}</span>
                      <button mat-icon-button (click)="removeAttachment(i)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  }
                }
              </div>
            }
            <form [formGroup]="messageForm" novalidate action="#">
              <tidy-message-input
                #messageInput
                formControlName="message"
                [placeholder]="'Send Message'"
                [form]="messageForm.controls.message"
                [rightIconAction]="boundSendMessage"
                [leftIconAction]="((pro?.chat_room_key || chatRoomKey) | isTextOnlyGuestChatRoom: pro?.isGuest) ? null : boundSendAttachment"
                [icon]="null"
                [isSendingMessage]="isSendingMessage"
                [hasAttachment]="attachmentPreviews.length > 0" />
            </form>
          </div>
        </ion-content>
      }
